module.exports = __webpack_public_path__ + "b21adb35bcc2e082e721ee280dfef10e.pdf";